import React, { useEffect, useRef, useState } from "react";
import "../../styles/Blog/Blogs.css";
import FeaturedThisMonth from "../../components/Blogs/FeaturedThisMonth";
import PopularPosted from "../../components/Blogs/PopularPosted";
import { MobileBlogs } from "../../components/Blogs/MobileComponent/MobileBlogs";
import MobilePopular from "../../components/Blogs/MobileComponent/MobilePopular";
import RecentlyPosted from "../../components/Blogs/RecentlyPosted";
import AddContainer from "../../components/AddComponents/AddContainer";
import Categories from "../../components/Blogs/Categories";
import TodaysUpdate from "../../components/Blogs/TodaysUpdate";
import SearchTags from "../../components/Blogs/SearchTags";
import RecentlyPostedMobile from "../../components/Blogs/MobileComponent/RecentlyPostedMobile";
import Loading from "../../components/Loading/Loading";
import { getBlogs } from "../../ReuableFunctions/Blogs";
import Pagination from "../../components/Blogs/Pagination";
import InstagramPost from "../../components/Blogs/InstagramPost";

const tags = [
  "All",
  "AI",
  "Testing",
  "Frontend",
  "Technology",
  "Business",
  "Design",
  "Java",
  "Entrepreneurship",
  "UI/UX",
];
const Blogs = () => {
  const blogsRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [blogs, setBlogs] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = isMobile ? 3 : 6;

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const blogsFromApi = await getBlogs();
        if (blogsFromApi["returnedRecords"] > 0) {
          setBlogs(blogsFromApi["blogs"]);
        }
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching blogs: ", err);
        setIsLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  // Scroll to view when page changes
  useEffect(() => {
    console.log(blogsRef);
    blogsRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [currentPage]); // Runs whenever `currentPage` updates
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    console.log("This will only render when selected category will change");
  }, [selectedCategory]);

  const totalPages = Math.ceil(blogs.length / blogsPerPage);
  const startIndex = (currentPage - 1) * blogsPerPage;
  const paginatedBlogs = blogs.slice(startIndex, startIndex + blogsPerPage);

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  if (isLoading) {
    return <Loading />;
  }
  return (
    <div className="blogs-container">
      <div className="blogs-month-popular-container">
        <h1 className="blogs-header">Blogs</h1>
        <div className="blogs-desc">
          Let’s Learn Something Extraordinary Together 
        </div>
        {!isMobile && (
          <div className="blogs-month-popular-innercontainer">
            <FeaturedThisMonth blogs={blogs.slice(0, 2)} />
            <PopularPosted blogs={blogs.slice(0, 5)} />
          </div>
        )}

        {isMobile && <MobilePopular blogs={blogs} />}
        {isMobile && <MobileBlogs blogs={blogs.slice(0, 2)} />}
      </div>

      {/* RECENTLY POSTED AND SEARCH */}
      <div className="recently-posted-and-search-container">
        {!isMobile && (
          <>
            <div className="recently-posted-and-search-innercontainer">
              <div className="recently-posted-container">
                <div className="recently-title" ref={blogsRef}>Recently Posted</div>
                <RecentlyPosted blogs={paginatedBlogs} />
                <Pagination
                  handlePrev={handlePrev}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  setCurrentPage={setCurrentPage}
                  handleNext={handleNext}
                />
              </div>
              <div className="search-tags-container">
                <div className="search-tag-title">Search With Tags</div>
                <SearchTags
                  tags={tags}
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                />
                <AddContainer />
                <Categories />
                <TodaysUpdate />
                <InstagramPost />
              </div>
            </div>
          </>
        )}
      </div>
      {/* RECENTLY POSTED AND TODDAYS UPDATE FOR MOBILE */}
      <div className="recently-posted-and-update-mobile-container">
        <div className="recently-posted-and-update-mobile-innercontainer">
          {isMobile && <RecentlyPostedMobile blogs={paginatedBlogs} ref={blogsRef} />}
          {isMobile && (
            <Pagination
              handlePrev={handlePrev}
              currentPage={currentPage}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
              handleNext={handleNext}
            />
          )}
          {isMobile && <TodaysUpdate />}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
